module.exports = __webpack_public_path__ + "static/solar-3b392ef8fd69d0fa3edf6bcce4df4fbc.jpeg";